import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchString: "",
  employeeTimeOffRequestFoundByReferenceNumberSearch: null,
  employeeTimeOffRequestFoundByReferenceNumberSearchIsLoading: false,
  employeeTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen: false,
  searchStringErrors: "",
  selectedWorkgroup: "",
  selectedDate: null,
  availableWopTypes: [],
  selectedWopType: "",
};

export const employeeTimeOffRequestWOPSlice = createSlice({
  name: "employeeTimeOffRequestWOP",
  initialState,
  reducers: {
    updateSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    updateEmployeeTimeOffRequestFoundByReferenceNumberSearch: (state, action) => {
      state.employeeTimeOffRequestFoundByReferenceNumberSearch = action.payload;
    },
    updateEmployeeTimeOffRequestFoundByReferenceNumberSearchIsLoading: (state, action) => {
      state.employeeTimeOffRequestFoundByReferenceNumberSearchIsLoading = action.payload;
    },
    updateEmployeeTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen: (state, action) => {
      state.employeeTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen = action.payload;
    },
    updateSearchStringErrors: (state, action) => {
      state.searchStringErrors = action.payload;
    },
    updateSelectedWorkgroup: (state, action) => {
      state.selectedWorkgroup = action.payload;
    },
    updateSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    updateAvailableWopTypes: (state, action) => {
      state.availableWopTypes = action.payload;
    },
    updateSelectedWopType: (state, action) => {
      state.selectedWopType = action.payload;
    },
    clearAllEmployeeTimeOffRequestWOPFilters: () => initialState,
  },
});

export const {
  updateSearchString,
  updateEmployeeTimeOffRequestFoundByReferenceNumberSearch,
  updateEmployeeTimeOffRequestFoundByReferenceNumberSearchIsLoading,
  updateEmployeeTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen,
  updateSearchStringErrors,
  clearAllEmployeeTimeOffRequestWOPFilters,
  updateSelectedWorkgroup,
  updateSelectedDate,
  updateSelectedWopType,
  updateAvailableWopTypes,
} = employeeTimeOffRequestWOPSlice.actions;

export const selectEmployeeTimeOffRequestWOPData = (state) => state.employeeTimeOffRequestWOP;

export default employeeTimeOffRequestWOPSlice.reducer;
